import { P, Predicate } from "breadcommon";
import { useContext } from "react";
import { AccountsContext } from "../firebaseio/AccountsContext";

export interface TransactionColumnFilterDisplayAccountProps {
  predicate: Predicate;
}

export function TransactionColumnFilterDisplayAccount({
  predicate,
}: TransactionColumnFilterDisplayAccountProps): JSX.Element {
  const accounts = useContext(AccountsContext);

  // Parse the predicate to extract selected account IDs
  // Expected structure: P.Any(P.Equals(P.Field("account_id"), P.Literal(id1)), P.Equals(..., id2), ...)
  const serializable = predicate.asSerializable();

  const accountIds: string[] = [];

  if (serializable.name === P.OpName.Any && serializable.args.length > 0) {
    // Multiple accounts in P.Any
    for (const arg of serializable.args) {
      if (arg.name === P.OpName.Equals && arg.args.length === 2) {
        const literalOp = arg.args[1];
        if (
          literalOp.name === P.OpName.Literal &&
          typeof literalOp.args[0] === "string"
        ) {
          accountIds.push(literalOp.args[0]);
        }
      }
    }
  } else if (
    serializable.name === P.OpName.Equals &&
    serializable.args.length === 2
  ) {
    // Single account
    const literalOp = serializable.args[1];
    if (
      literalOp.name === P.OpName.Literal &&
      typeof literalOp.args[0] === "string"
    ) {
      accountIds.push(literalOp.args[0]);
    }
  }

  // Get account names
  const accountNames = accountIds
    .map((id) => accounts.get(id)?.name)
    .filter((name): name is string => name !== undefined);

  if (accountNames.length === 0) {
    return <span>Account filter</span>;
  } else if (accountNames.length === 1) {
    return <span>Account is {accountNames[0]}</span>;
  } else if (accountNames.length <= 3) {
    return <span>Account is {accountNames.join(", ")}</span>;
  } else {
    return (
      <span>
        Account is {accountNames.slice(0, 2).join(", ")}, +
        {accountNames.length - 2} more
      </span>
    );
  }
}
